import { Box, Typography, Button } from "@mui/material";
import React from "react";
// Import hook for programmatic navigation
import { useNavigate } from "react-router-dom";
// Import Redux hook for accessing state
import { useSelector } from "react-redux";

// Define the SystemStory component
const SystemStory = () => {
  // Hook for navigation
  const navigate = useNavigate();
  // Access purchased subscription status from Redux store
  const purchasedSubscription = useSelector(
    (state) => state.auth.purchasedSubscription
  );
  // Access chat enabled status from Redux store
  const chatEnabled = useSelector((state) => state.auth.chatEnabled);

  // Handle button click to navigate to subscription details
  const handleOpenPdf = () => {
    if (purchasedSubscription) {
      navigate("/subscription-details");
    }
    // Note: Commented-out code for opening a PDF in a new tab
    // window.open(
    //   "https://apidev.recompplus.com/storage/documents/SHS81OhPAMB2lfzzXCYHrz80c6R4HiH3JBBYwQML.pdf",
    //   "_blank"
    // );
  };

  // Log chatEnabled status for debugging
  console.log('dasd', chatEnabled);

  return (
    <>
      {/* Main container for the system story section */}
      <div className="systemStory" style={{ backgroundColor: "#111111" }}>
        <Box
          className="container"
          sx={{
            display: "flex",
            justifyContent: "start",
            alignItems: "start",
            flexDirection: "column",
            py: 6,
            px: 6,
            color: "#fff",
          }}
        >
          {/* Section subtitle */}
          <Typography
            variant="overline"
            sx={{
              color: "#fff",
              fontSize: "10px",
              letterSpacing: "10px",
              fontWeight: "700",
            }}
          >
            Why I Built This System?
          </Typography>

          {/* Section title */}
          <Typography
            variant="h4"
            sx={{
              fontWeight: 800,
              mt: 2,
              textAlign: "start",
              textTransform: "uppercase",
              color: "#fff",
              fontSize: {
                xs: "15px",
                sm: "20px",
                md: "25px",
                lg: "35px",
              },
              maxWidth: { xs: "100%", sm: "80%", md: "75%", lg: "60%" },
            }}
          >
            I Was Coaching Full-Time And Training Hard, But My Body Was Falling Apart.
          </Typography>

          {/* Shortened story content */}
          <Box
            sx={{
              mt: 5,
              color: "#fff",
              maxWidth: { xs: "100%", sm: "90%", md: "80%", lg: "75%" },
              display: "flex",
              textAlign: "start",
              flexDirection: "column",
              gap: 2,
            }}
          >
            <Typography>
              I built Recomp Plus first to fix myself — then for my clients. It combines structure, accountability, and proven methods that work in real life.
            </Typography>
            <Typography>
              This system rebuilt me, and it will rebuild you.
            </Typography>
          </Box>

          {/* Call-to-action button */}
          <Button
            variant="outlined"
            sx={{
              backgroundColor: "#00ffffff",
              borderRadius: "25px",
              borderColor: "#00ffff",
              color: "#000",
              fontWeight: 600,
              mt: 3,
              textTransform: "none",
              px: { xs: 2.5, sm: 3, md: 4 },
              py: { xs: 0.75, sm: 1, md: 1.5 },
              fontSize: { xs: "0.8rem", sm: "0.9rem", md: "1rem" },
              minWidth: { xs: "140px", sm: "auto" },
              transition: "all 0.3s ease",
              "&:hover": {
                backgroundColor: "#00ffff",
                transform: "translateY(-2px)",
                boxShadow: "0 4px 12px rgba(0, 198, 194, 0.3)",
              },
            }}
            onClick={handleOpenPdf}
            disabled={chatEnabled}
          >
            Get the Blueprint
          </Button>
        </Box>
      </div>
    </>
  );
};

// Export the SystemStory component
export default SystemStory;